var exports = {
  "R": "x234b8571--e46574--hidden",
  "MM": "x234b8571--e46574--align",
  "kL": "x234b8571--e46574--container",
  "AS": "x234b8571--e46574--item",
  "yy": "x234b8571--e46574--fullwidth",
};

module.exports = exports;
